import { Navigate } from 'react-router-dom';
import { getSession } from '../utils/api';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { sessionToken, variantId } = getSession();

    if (!sessionToken || !variantId) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;